import { gql } from "@apollo/client";

const AddUserMutation = gql`
  mutation addUserMutation(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $external: Boolean!
    $admin: Boolean!
  ) {
    addUser(
      input: {
        tfirstName: $firstName
        tlastName: $lastName
        temail: $email
        tpassword: $password
        texternal: $external
        tadmin: $admin
      }
    ) {
      user {
        appId
        email
        firstName
        lastName
        uploadsByUserId {
          totalCount
        }
      }
    }
  }
`;
const hash = "c155dfeeaf575ddec2af3ce0532b53b217429d76452208dd18af33f0e2acbe62";

export { AddUserMutation, hash };
